<template>
  <div class="wrap area main-container" ref="outerDom">
    <!-- 内容 -->
    <div class="pz-normal-scroll-container position-relative">
      <div class="pz-container-cont position-relative ">
        <!-- 内容区域 -->
        <div class="pz-container-wrapper">
          <ul class="rightList">
            <li id="id0">
              <info />
            </li>
            <li id="id1">
              <reserve />
            </li>
            <li id="id2">
              <rolePage />
            </li>
            <li id="id3">
              <worldview @showVideo="videoFlag = true" />
            </li>
          </ul>
        </div>
      </div>

      <!-- backicon -->
      <div class="backicon cursor" v-if="navFlag">
        <img
          src="../assets/img/top.png"
          alt=""
          srcset=""
          class="icon"
          @click="handleTop()"
        />
      </div>
    </div>
    <!-- 菜单 -->
    <div class="navgator">
      <ul
        class="
        menu-list
        position-absolute
      "
      >
        <li
          class="navgatorLi cursor"
          :class="{ isActive: index === navgatorIndex }"
          @click="handleLeft(index)"
          v-for="(item, index) in navgator"
          :key="index"
        >
          <div :class="index == navgatorIndex ? 'choose-menu' : ''">
            {{ item.text }}
          </div>
        </li>
      </ul>
      <div class="pay-btn cursor" @click="handlePay()"></div>
      <div class="share-icon cursor">
        <img
          src="../assets/img/menu/dc.png"
          alt=""
          srcset=""
          class="icon"
          @click="handleDC('dc')"
        />
        <img
          src="../assets/img/menu/tw.png"
          alt=""
          srcset=""
          class="icon"
          @click="handleTW('twi')"
        />
        <img
          src="../assets/img/menu/ytub.png"
          alt=""
          srcset=""
          class="icon"
          @click="handleYtub('youtube')"
        />
      </div>
    </div>
    <!-- footer =copyright -->
    <div class="footer">
      <img src="../assets/img/f-msg.png" alt="" srcset="" class="f-msg" />
      <div class="policy">
        <img src="../assets/img/logo.png" alt="" srcset="" class="f-logo" />
        <div class="lr-txt">
          <a
            href="https://dorganenai.ujoygames.com/faq/index.html"
            target="_blank"
            class="faq"
          >
            お問い合わせ
          </a>
          <span>|</span>
          <a
            href="https://settlement.ujoygames.jp/"
            target="_blank"
            class="settlement"
            >資金決済法に基づく表示</a
          >
          <span>|</span>
          <a
            href="https://privacy.ujoygames.jp/"
            target="_blank"
            class="privacy"
            >プライバシーポリシー</a
          >
          <span>|</span>
          <a
            href="https://useragreement.ujoygames.jp/"
            target="_blank"
            class="useragreement"
            >利用規約</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reserve from "./mainComponents/reserve";
import rolePage from "./mainComponents/rolePage";
import worldview from "./mainComponents/worldview";
import info from "./mainComponents/info";

export default {
  components: {
    reserve,
    rolePage,
    worldview,
    info
  },
  data() {
    return {
      navFlag: false,
      navgator: [
        {
          id: 0,
          text: "予約特典"
        },
        {
          id: 1,
          text: "キャラクター"
        },
        {
          id: 2,
          text: "ストーリー"
        },
        {
          id: 3,
          text: "ゲーム情報"
        }
      ],
      navgatorIndex: 0,
      navgatorIndexShow: false, // 是否显示
      listBox: ["A", "B", "C", "D"],
      listBoxState: true, //点击导航栏时，暂时停止监听页面滚动
      scrollTrigger: false, //默认初始值
      scrollTop: 0 //默认距离顶部的距离
    };
  },
  created() {},
  mounted() {
    let timeId;
    window.addEventListener(
      "scroll",
      () => {
        // 页面滚动停止100毫秒后才会执行下面的函数。
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.scrollToTop();
          // console.log("执行完了哦");
        }, 100);
      },
      true
    );
  },

  methods: {
     handlePay() {
       window.open(`https://dorganenai.ujoygames.com/pay/`, '_blank');

    },
    handleTop() {
      // 获取当前距离顶部的距离
      let scrollTop = this.scrollTop;
      document.body.scrollTop = 0;
    },
    handleDC(val) {
      this.common.goShare(val);
    },
    handleTW(val) {
      this.common.goShare(val);
    },
    handleYtub(val) {
      this.common.goShare(val);
    },

    // 点击导航菜单，页面滚动到指定位置
    handleLeft(index) {
      this.navgatorIndex = index;
      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start"
      });
      this.listBoxState = false;

      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      this.scrollTop = scrollTop;
      // 菜单显示

      // 首页按钮隐藏/显示
      if (scrollTop >= 200) {
        this.navFlag = true;
      } else {
        this.navFlag = false;
      }
      if (this.listBoxState) {
        //作用是点击导航栏时，延迟这里执行。
        this.listBox.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(`id${i}`).offsetTop;

          // 动画

          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(`id${i}`).scrollHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.navgatorIndex = i;
          }
        });
      } else {
      }
    }
  },
  destroyed() {
    window.removeEventListener(
      "scroll",
      () => {
        this.scrollToTop();
        // console.log("销毁完了哦");
      },
      true
    );
  }
};
</script>

<style lang="scss">
.area {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  overflow: hidden;
}

.wrap {
  width: 100%;
  max-width: 1920px;
  width: 1920px;
  margin: 0 auto;

  .backicon {
    position: fixed;
    right: 1vw;
    bottom: 6vw;
    z-index: 1;
    img {
      width: 80px;
      height: auto;
    }
  }

  .main-container {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
  }

  .pz-normal-scroll-container {
    width: 100%;
    height: auto;
    min-height: 100vh;

    .pz-container-cont {
      overflow: visible;
      width: 1920px;
      height: auto;

      .pz-container-wrapper {
        background: center center / cover no-repeat;
        overflow: visible;
        position: relative;
        width: 1920px;
        top: 0;
      }
    }
  }

  .navgator {
    width: 100%;
    height: 60px;
    background-color: #2d6ebe;
    border: solid 0vw #ffffff;
    opacity: 0.9;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;

    .menu-list {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5vw;
    }

    .navgatorLi {
      text-align: center;
      font-family: "Noto Sans SC", sans-serif;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 1px;
      color: #a7d4ff;
      height: 60px;
      line-height: 60px;
      position: relative;
    }

    .choose-menu {
      color: #fff;
      font-weight: bold;
      padding: 0 1.5vw;
    }
    .choose-menu::after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: 0;
      width: 21px;
      height: 15px;
      background: url("../assets/img/menu/arrow-lr.png") no-repeat center top;
    }
    .choose-menu::before {
      content: "";
      background: url("../assets/img/menu/arrow-lf.png") no-repeat center top;

      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: 0;
      width: 21px;
      height: 15px;
    }
    .isActive {
      color: #fff;
    }
  }
  .pay-btn {
    position: absolute;
    right: 14vw;
    top: .1vw;
    height: 38px;
    width: 240px;
    background-image: url("../assets/img/menu/pay.png");
    background-size: 100% 100%;

    &:hover {
      background-image: url("../assets/img/menu/pay-active.png");
    }
  }

  .share-icon {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: absolute;
    right: 2vw;
    top: 0;
    .icon {
      width: 45px;
      height: 45px;
    }
  }

  .rightList {
    li {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      // border: 1px solid #ccc;
    }
  }

  .footer {
    width: 1920px;
    height: 364px;
    background-color: #2c2c2c;
    opacity: 0.93;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2vw;
    .f-msg {
      height: 202px;
      width: auto;
    }
    .policy {
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .f-logo {
        height: 45px;
        width: auto;
      }
      .lr-txt {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 31px;
        height: 31px;
        letter-spacing: 0px;
        color: #ffffff;
        display: flex;
        align-items: start;
        justify-content: center;
        gap: 1vw;
      }
    }
  }
}
@media (min-width: 3440px) {
}
</style>



// WEBPACK FOOTER //
// src/components/MainIndex.vue